import { Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import { AiInsightsIcon } from 'assets/icons/AiInsightsIcon';
import { content } from 'components/AiInsights/AiInsights.content';
import { AiInsightsModalCallable } from 'components/AiInsights/AiInsightsBottomSheet';

const AiInsightsDetailsHeader = ({
  visibilityPercentage,
  code,
  productType,
}: {
  visibilityPercentage: number;
  code: string;
  productType?: string;
}) => {
  const aiLocalizedContent = useContent(content);
  return (
    <div
      style={{
        opacity: visibilityPercentage < 50 ? 1 : 0,
        transition: 'opacity 0.2s ease-in-out',
        pointerEvents: visibilityPercentage < 50 ? 'auto' : 'none',
      }}
      className="absolute right-3 flex items-center gap-2">
      <Typography size="medium" className="text-neutral-300">
        {aiLocalizedContent.title}
      </Typography>
      <button
        className="bg-[#B393FF] rounded-full h-8 w-8 flex justify-center items-center"
        disabled={false}
        onClick={() =>
          AiInsightsModalCallable.call({
            pageName: 'Assets',
            productCode: code,
            productType: productType,
          })
        }>
        <div className="stroke-neutral-600">
          <AiInsightsIcon />
        </div>
      </button>
    </div>
  );
};
export default AiInsightsDetailsHeader;
